export default __webpack_public_path__ + "static/blog-0a398ba1fa61c5d91ea1feb082d2ad5c.gif";